<template>
  <div id="SecurityCheck">
    <app-logo></app-logo>
    <header v-if="survey[$route.params.survey]" class="questions-header" :style="'background-image:url('+survey[$route.params.survey].topbillede1+')'">
    </header>
    <app-spinner v-if="spinner"></app-spinner>
    <transition name="fade" mode="out-in">
      <router-view class="view"></router-view>
    </transition>
  </div>
</template>


<script>
import Spinner from './components/modular/spinner.vue';
import Logo from './components/modular/logo.vue';
import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
import {db} from './database/firebase';



export default {
  name: 'SecurityCheck',
  components: {
    appSpinner: Spinner,
    appLogo: Logo
  },
  mounted() {

  },
  data () {
    return {

    }
  },
  firebase: {
    questions: {
      source: db.ref('surveys'),
      readyCallback: function () {
        this.setSurvey(this.questions);
        this.setSpinner(false);
        this.setAnswers(this.questions);
        this.setQnumber();
        for (var key in this.questions) {
          for (var ckey in this.questions[key].cat) {
            for (var skey in this.questions[key].cat[ckey].questions) {
              this.survey[key].cat[ckey].questions[skey].picked = [];
            }
          }
        }
      }
    },
    globalC: {
      source: db.ref('global'),
      asObject: true,
      readyCallback: function () {
        this.setGlobal(this.globalC);
      }
    }
  },
  computed: {
      ...mapGetters([
        'survey',
        'spinner',
        'answers',
        'qaNumber'
      ]),
  },
  methods:{
      ...mapActions([
        'setSurvey',
        'setSpinner',
        'setAnswers',
        'setQnumber',
        'setGlobal'
      ])
  }
}
</script>
<style lang="scss" src="./assets/css/main.scss"></style>



// WEBPACK FOOTER //
// src/App.vue